import styled from '@emotion/styled';

export const Mark = styled.mark`
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.palette.data.orange : theme.palette.yellow['50']};
`;
